<template>
	<div>
		<div class="enquiry-container">
			<div class="flex-wrap enquiry-box" v-if="adClicks > 0">
				<div class="enquiry-logo-title flex-centered"><span class="enquiry-logo ad-click-logo">&nbsp;</span>Ad Clicks</div>
				<div class="enquiry-logo-value flex-centered">
					{{ adClicks.toLocaleString() }}
				</div>
				<div class="enquiry-logo-tooltip flex-centered">
					Total number of clicks on your ads.
				</div>
			</div>
			<div class="flex-wrap enquiry-box" v-if="salesAppraisalLeads > 0">
				<div class="enquiry-logo-title flex-centered"><span class="enquiry-logo enquiries-logo">&nbsp;</span>Sales Appraisal Leads</div>
				<div class="enquiry-logo-value flex-centered">
					{{ salesAppraisalLeads.toLocaleString() }}					
				</div>
				<div class="enquiry-logo-tooltip flex-centered">
					The number of sales appraisal leads submitted
				</div>
			</div>			
		</div>
		<div class="conditions-text">
			<p>
				Campaign metrics demonstrate the awareness generated with potential vendors within your target markets.  <br/>
				A consistent online presence helps build your brand and your new listing opportunities. 
			</p>
		</div>
	</div>
</template>
	
<script>
export default {
	props: ['campaign'],
	data() {
		return {
			adClicks: this.campaign.stats && this.campaign.stats.clicks ? Number(this.campaign.stats.clicks) : 0,
			salesAppraisalLeads: this.campaign.stats && this.campaign.stats.conversions && this.campaign.stats.conversions.SocialFormLeads ? Number(this.campaign.stats.conversions.SocialFormLeads) : 0
		}
	}
}
</script>